import GridItem from "../../components/general/GridItem";
import RichText from "../../components/general/RichText";

const RichtextContainerModule = ({
	richtext,
	centered_text,
}: Queries.RichtextContainerModuleFragment) => (
	<GridItem>
		{richtext && <RichText content={richtext} centeredText={centered_text} />}
	</GridItem>
);
export default RichtextContainerModule;
